import { useState } from 'react';

import { QueryTable } from '@app/components/common/table';
import { useApi, useFetchData } from '@app/hooks';
import { Dialog } from '@app/components/common';
import { usePermissions } from '@app/hooks/use-permissions';
import { ROLES } from '@app/navigation/types';
import Error404 from '@app/pages/errors/404';

import { useColumns } from './columns';
import { PositionsForm } from './form';

export const PositionsTable = () => {
  const api = useApi();
  const [fetchData] = useFetchData<EntityBase>({ method: api.users.getPositions });

  const hasPermission = usePermissions({ roles: [ROLES.ADMIN, ROLES.CHIEF] });

  const [selectedPosition, setSelectedposition] = useState<EntityBase>();
  const [modal, setModal] = useState<'add' | 'edit' | 'remove' | null>(null);

  const columns = useColumns({
    onEdit: (item: EntityBase) => {
      setSelectedposition(item);
      setModal('edit');
    }
  });

  const onFormSubmit = async (instance: EntityBase) => {  
    setModal(null);
  };


  if (!hasPermission) {return <Error404/>;}

  return <>
    <QueryTable<EntityBase>
      title="Должности"
      columns={columns}
      fetchData={fetchData}
      onCreateClick={() => {
        setSelectedposition(undefined);
        setModal('add');
      }}
    >
      <Dialog open={modal === 'edit' || modal === 'add'}
        onClose={() => setModal(null)}
        title={modal === 'edit' ? 'Редактирование' : 'Добавление'}
        width={800}
      >
        <PositionsForm
          initial={modal === 'edit' ? selectedPosition : undefined}
          onSubmit={onFormSubmit}
          onCancel={() => setModal(null)}
        />
      </Dialog>
    </QueryTable>
  </>;
};